import React from 'react';
import { X, AlertCircle } from 'lucide-react';

const NoAssociationModal = ({ isOpen, onClose, hasPendingClaim = false }) => {
  if (!isOpen) return null;

  // Ett lägenhetsanspråk som väntar på Hyrias godkännande är inte samma sak
  // som att föreningen saknas — att blanda ihop dem förvirrar både medlem
  // och styrelse.
  const title = hasPendingClaim ? 'Inväntar godkännande' : 'Förening krävs';
  const message = hasPendingClaim
    ? 'Din lägenhet inväntar ett godkännande från Hyria. När den är godkänd kommer den att läggas till under mina lägenheter.'
    : 'Din förening är inte medlem i Hyria. Kontakta din förening och tipsa om Hyria.';

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 z-50 p-4"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh'
      }}
    >
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full mx-auto overflow-hidden transform transition-all duration-300 ease-out"
           style={{ maxHeight: '90vh', overflowY: 'auto' }}>
        
        {/* Header */}
        <div className="px-6 py-8 text-center relative" style={{ backgroundColor: '#62B8E9' }}>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white hover:text-gray-200 transition-colors"
          >
            <X size={24} />
          </button>
          <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertCircle className="text-white" size={32} />
          </div>
          <h2 className="text-xl font-bold text-white mb-2" style={{ fontFamily: "'Poppins', sans-serif" }}>
            {title}
          </h2>
        </div>

        {/* Content */}
        <div className="p-6 text-center">
          <p className="text-gray-700 mb-6 leading-relaxed" style={{ fontFamily: "'Poppins', sans-serif" }}>
            {message}
          </p>

          <p className="text-sm text-gray-600 mb-6">
            Kontakta oss på{' '}
            <a href="mailto:info@hyria.se" className="font-semibold underline" style={{ color: '#62B8E9' }}>
              info@hyria.se
            </a>
          </p>

          {/* Close Button */}
          <button
            onClick={onClose}
            className="w-full text-white font-semibold py-3 rounded-xl hover:opacity-90 transition-colors focus:outline-none"
            style={{ backgroundColor: '#62B8E9', fontFamily: "'Poppins', sans-serif" }}
          >
            Stäng
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoAssociationModal;
